import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ai-answer delay-in-1000" }
const _hoisted_2 = { class: "answer-body" }
const _hoisted_3 = {
  key: 0,
  class: "answer-content"
}
const _hoisted_4 = {
  key: 0,
  class: "start row-hvcenter"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiLogo = _resolveComponent("AiLogo")
  const _component_Answer = _resolveComponent("Answer")
  const _component_AiInput = _resolveComponent("AiInput")
  const _component_Research = _resolveComponent("Research")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Logo = _resolveComponent("Logo")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AiLogo, {
        class: "icon row-hvcenter",
        animate: $data.animate_logo,
        stroke: "var(--brand-500)"
      }, null, 8 /* PROPS */, ["animate"]),
      ($options.text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Answer, {
              ref: "answer",
              class: "text",
              text: $options.text,
              intermediate: $props.item.intermediate,
              generating: $props.generating,
              onTextAdded: $options.onTextAdded
            }, null, 8 /* PROPS */, ["text", "intermediate", "generating", "onTextAdded"]),
            ($options.input)
              ? (_openBlock(), _createBlock(_component_AiInput, {
                  key: 0,
                  class: "ai-buttons",
                  disabled: !$props.lastAnswer,
                  input: $options.input,
                  onPrompt: _cache[0] || (_cache[0] = $event => (_ctx.$emit('ask-ai', $event)))
                }, null, 8 /* PROPS */, ["disabled", "input"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createBlock(_component_Research, {
            key: 1,
            class: "typing",
            reasoning: $options.status,
            mode: "onboarding"
          }, null, 8 /* PROPS */, ["reasoning"]))
    ]),
    ($props.item.data?.extracted_info && !$options.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "button",
            primary: "",
            disabled: $data.completed,
            onClick: _cache[1] || (_cache[1] = $event => ($options.onStart()))
          }, {
            default: _withCtx(() => [
              ($data.completed)
                ? (_openBlock(), _createBlock(_component_Loader, {
                    key: 0,
                    inline: "",
                    small: "",
                    color: "var(--base-white)"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_Logo, {
                      class: "logo",
                      color: "var(--base-white)",
                      size: "1.5rem"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode(" Start Now "))
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}